import styled from 'styled-components'

export const CorrectAnswerBox = styled.div`
  padding-left: 20px;
`
